import { render, staticRenderFns } from "./AuthorityLetterAgen.vue?vue&type=template&id=0aefe3eb&scoped=true"
import script from "./AuthorityLetterAgen.vue?vue&type=script&lang=js"
export * from "./AuthorityLetterAgen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aefe3eb",
  null
  
)

export default component.exports